import React from "react";
import { Box, Typography, Grid, Card, CardContent, Button, Divider, Table, TableHead, TableRow, TableCell, TableBody, Chip, IconButton } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import CloseIcon from "@mui/icons-material/Close";
import OlympiadClubbingPdf from "./modals/OlympiadClubbingPdf";

const ViewOlympiadClubbingModal = ({ closePopup, modalData }) => {
    console.log("Modal Data:", modalData);
    const formatDate = (date) => {
        if (!date) return "-";

        return new Date(date).toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric"
        });
    };

    const getStatusColor = (status) => {
        switch (status) {
            case "completed":
                return "success";

            case "pending":
                return "warning";

            default:
                return "default";
        }
    };
    // CLUB ALL REGISTRATION LINE ITEMS TOGETHER
    const groupedAllLineItems = Object.values(
        (modalData?.registrations || [])
            ?.flatMap(reg => reg?.allRegistrationLineItemes || [])
            ?.reduce((acc, item) => {

                const key = `${item?.class_name}_${item?.subject_name}_${item?.medium_name}`;

                if (!acc[key]) {
                    acc[key] = {
                        class_name: item?.class_name,
                        subject_name: item?.subject_name,
                        medium_name: item?.medium_name,
                        student: 0,
                        study_material: 0,
                        subject_price: 0
                    };
                }

                acc[key].student += Number(item?.student || 0);

                acc[key].study_material += Number(item?.study_material || 0);

                acc[key].subject_price += Number(item?.subject_price || 0);

                return acc;

            }, {})
    );
    const handleDownloadPDF = () => {

        OlympiadClubbingPdf(modalData);
    };

    return (
        <Box
            sx={{
                backgroundColor: "#f5f7fb",
                height: "100%",
                overflowY: "auto"
            }}
        >

            {/* HEADER */}
            <Box
                sx={{
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                    backgroundColor: "#fff",
                    borderBottom: "1px solid #ddd",
                    px: 3,
                    py: 2,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }}
            >
                <Box>
                    <Typography variant="h5" fontWeight="bold" style={{ fontWeight: "800", color: "#000" }}>
                        Olympiad Summary - <span style={{ fontWeight: "600", fontSize: "16px", color: "#000" }}>{modalData?.schoolName} ({modalData?.partyId})</span>
                    </Typography>
                    <Typography variant="h6" fontWeight="bold" style={{ borderTop: "2px solid #000000", marginTop: "4px", color: "#000" }}>
                        Olympiad Date - {formatDate(modalData?.registrations[0]?.exam_date)}
                    </Typography>
                </Box>

                <IconButton onClick={closePopup}
                    sx={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                        color: "#000"
                    }}>
                    <CloseIcon />
                </IconButton>
            </Box>

            <Box p={3}>

                {/* OVERVIEW */}
                <Grid container spacing={2} mb={3}>

                    <Grid item xs={12} md={2}>
                        <Card>
                            <CardContent>
                                <Typography variant="body2" sx={{ color: "#000", fontWeight: "600", }}>
                                    Registrations
                                </Typography>

                                <Typography variant="h5" fontWeight="bold" sx={{ color: "#000", fontWeight: "600", }}>
                                    {modalData?.totalRegistrations}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} md={2}>
                        <Card>
                            <CardContent>
                                <Typography variant="body2" sx={{ color: "#000", fontWeight: "600", }}>
                                    Total Amount
                                </Typography>

                                <Typography variant="h5" fontWeight="bold" sx={{ color: "#000", fontWeight: "600", }}>
                                    ₹ {modalData?.overAllAmount}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} md={2}>
                        <Card>
                            <CardContent>
                                <Typography variant="body2" sx={{ color: "#000", fontWeight: "600", }}>
                                    Paid
                                </Typography>

                                <Typography
                                    variant="h5"
                                    fontWeight="bold"
                                    color="green"
                                >
                                    ₹ {modalData?.overAllPaid}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} md={2}>
                        <Card>
                            <CardContent>
                                <Typography variant="body2" sx={{ color: "#000", fontWeight: "600", }}>
                                    Pending
                                </Typography>

                                <Typography
                                    variant="h5"
                                    fontWeight="bold"
                                    color="red"
                                >
                                    ₹ {modalData?.overAllPending}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} md={2}>
                        <Card>
                            <CardContent>
                                <Typography variant="body2" sx={{ color: "#000", fontWeight: "600", }}>
                                    Students
                                </Typography>

                                <Typography variant="h5" fontWeight="bold" sx={{ color: "#000", fontWeight: "600", }}>
                                    {modalData?.overAllStudents}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} md={2}>
                        <Card>
                            <CardContent>
                                <Typography variant="body2" sx={{ color: "#000", fontWeight: "600", }}>
                                    Study Material
                                </Typography>

                                <Typography variant="h5" fontWeight="bold" sx={{ color: "#000", fontWeight: "600", }}>
                                    {modalData?.overAllStudyMaterial}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>

                </Grid>

                {/* COORDINATORS */}
                <Card sx={{ mb: 3 }}>
                    <CardContent>

                        <Typography variant="h6" fontWeight="bold" mb={2} color={"#000"}>
                            Coordinators
                        </Typography>

                        <Grid>
                            <Table size="small"
                                sx={{
                                    border: "1px solid #000",
                                    // borderCollapse: "collapse",
                                    "& .MuiTableCell-root": {
                                        border: "1px solid #000",
                                    },
                                }}
                            >
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{ color: "#000", backgroundColor: "#dce3dd", fontWeight: "600", fontSize: "14px" }}>Name</TableCell>
                                        <TableCell style={{ color: "#000", backgroundColor: "#dce3dd", fontWeight: "600", fontSize: "14px" }}>Subject</TableCell>
                                        <TableCell style={{ color: "#000", backgroundColor: "#dce3dd", fontWeight: "600", fontSize: "14px" }}>Role</TableCell>
                                        <TableCell style={{ color: "#000", backgroundColor: "#dce3dd", fontWeight: "600", fontSize: "14px" }}>Mobile</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {modalData?.overAllCordinators?.map((item, index) => (
                                        <TableRow key={index}>
                                            <TableCell sx={{ color: "#000", fontWeight: "600", }}>{item?.name}</TableCell>
                                            <TableCell sx={{ color: "#000", fontWeight: "600", }}>{item?.subId == "9999" ? "General Coordinator" : item?.subject}</TableCell>
                                            <TableCell sx={{ color: "#000", fontWeight: "600", }}>{item?.role}</TableCell>
                                            <TableCell sx={{ display: "flex", alignItems: "center", justifyContent: "center", color: "#000", fontWeight: "600", }}>{item?.mobile}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Grid>

                    </CardContent>
                </Card>
                <Card sx={{ mb: 4 }}>
                    <CardContent>
                        <Typography
                            variant="h6"
                            fontWeight="bold"
                            color={"#000"}
                            mb={2}
                        >
                            Registered RNO IDs
                        </Typography>
                        <Grid container spacing={2}>

                            {modalData?.registrations?.map((ele, ind) => (

                                <Grid item xs={12} sm={6} md={3} key={ind}>

                                    <Box
                                        sx={{
                                            border: "1px solid #ddd",
                                            borderRadius: 2,
                                            p: 2,
                                            background: "#fff"
                                        }}
                                    >
                                        <Typography
                                            fontWeight="bold"
                                            fontSize={14}
                                            color={"#000"}
                                        >
                                            {ele?.rno_id}
                                        </Typography>
                                    </Box>

                                </Grid>
                            ))}

                        </Grid>

                    </CardContent>
                </Card>
                <Card sx={{ mb: 4 }}>
                    <Card sx={{ mb: 4 }}>
                        <CardContent>

                            <Typography
                                variant="h6"
                                fontWeight="bold"
                                mb={2}
                                color={"#000"}
                            >
                                Clubbed Data
                            </Typography>

                            <Table size="small"
                                sx={{
                                    border: "1px solid #000",
                                    // borderCollapse: "collapse",
                                    "& .MuiTableCell-root": {
                                        border: "1px solid #000",
                                    },
                                }}
                            >
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{ color: "#000", backgroundColor: "#dce3dd", fontWeight: "600", fontSize: "14px" }}>Class</TableCell>
                                        <TableCell style={{ color: "#000", backgroundColor: "#dce3dd", fontWeight: "600", fontSize: "14px" }}>Subject</TableCell>
                                        <TableCell style={{ color: "#000", backgroundColor: "#dce3dd", fontWeight: "600", fontSize: "14px" }}>Medium</TableCell>
                                        <TableCell style={{ color: "#000", backgroundColor: "#dce3dd", fontWeight: "600", fontSize: "14px" }}>Students</TableCell>
                                        <TableCell style={{ color: "#000", backgroundColor: "#dce3dd", fontWeight: "600", fontSize: "14px" }}>Study Material</TableCell>
                                        {/* <TableCell style={{ color: "#000" }}>Price</TableCell> */}
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {groupedAllLineItems?.map((item, i) => (
                                        <TableRow key={i}>

                                            <TableCell sx={{ color: "#000", fontWeight: "600", }}>
                                                {item?.class_name}
                                            </TableCell>

                                            <TableCell sx={{ color: "#000", fontWeight: "600", }}>
                                                {item?.subject_name}
                                            </TableCell>

                                            <TableCell sx={{ color: "#000", fontWeight: "600", }}>
                                                {item?.medium_name}
                                            </TableCell>

                                            <TableCell align="center" sx={{ color: "#000", fontWeight: "600", }}>
                                                {item?.student}
                                            </TableCell>

                                            <TableCell align="center" sx={{ color: "#000", fontWeight: "600", }}>
                                                {item?.study_material}
                                            </TableCell>

                                            {/* <TableCell>
                                                ₹ {item?.subject_price}
                                            </TableCell> */}

                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>

                        </CardContent>
                    </Card>
                </Card>
            </Box>
            {/* TRANSACTION DETAILS */}
            <Card sx={{ mb: 4 }}>
                <CardContent>

                    <Typography
                        variant="h6"
                        fontWeight="bold"
                        mb={2}
                        color={"#000"}
                    >
                        Transaction Details
                    </Typography>

                    <Table size="small"
                        sx={{
                            border: "1px solid #000",
                            // borderCollapse: "collapse",
                            "& .MuiTableCell-root": {
                                border: "1px solid #000",
                            },
                        }}
                    >
                        <TableHead>
                            <TableRow>
                                <TableCell style={{ color: "#000", backgroundColor: "#dce3dd", fontWeight: "600", fontSize: "14px" }}>
                                    Reference No.
                                </TableCell>

                                <TableCell style={{ color: "#000", backgroundColor: "#dce3dd", fontWeight: "600", fontSize: "14px" }}>
                                    Payment Mode
                                </TableCell>

                                <TableCell style={{ color: "#000", backgroundColor: "#dce3dd", fontWeight: "600", fontSize: "14px" }}>
                                    Total Amount
                                </TableCell>

                                <TableCell style={{ color: "#000", backgroundColor: "#dce3dd", fontWeight: "600", fontSize: "14px" }}>
                                    Paid Amount
                                </TableCell>

                                <TableCell style={{ color: "#000", backgroundColor: "#dce3dd", fontWeight: "600", fontSize: "14px" }}>
                                    Pending Amount
                                </TableCell>

                                <TableCell style={{ color: "#000", backgroundColor: "#dce3dd", fontWeight: "600", fontSize: "14px" }}>
                                    Date
                                </TableCell>

                                <TableCell style={{ color: "#000", backgroundColor: "#dce3dd", fontWeight: "600", fontSize: "14px" }}>
                                    Status
                                </TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>

                            {modalData?.registrations
                                ?.flatMap((reg) =>
                                    (reg?.AllTransactions || []).map((txn, index) => ({
                                        ...txn,
                                        regNo: reg?.rno_id,
                                        key: `${reg?.rno_id}-${index}`
                                    }))
                                )
                                ?.map((txn) => (

                                    <TableRow key={txn?.key}>

                                        <TableCell sx={{ color: "#000", fontWeight: "600", }}>
                                            {txn?.transactionReference || "-"}
                                        </TableCell>

                                        <TableCell sx={{ color: "#000", fontWeight: "600", }}>
                                            {txn?.payment_mode || "-"}
                                        </TableCell>

                                        <TableCell align="center" sx={{ color: "#000", fontWeight: "600", }}>
                                            ₹ {txn?.totalAmount || 0}
                                        </TableCell>

                                        <TableCell align="center" sx={{ color: "#000", fontWeight: "600", }}>
                                            ₹ {txn?.paidAmount || 0}
                                        </TableCell>

                                        <TableCell align="center" sx={{ color: "#000", fontWeight: "600", }}>
                                            ₹ {txn?.pendingAmount || 0}
                                        </TableCell>

                                        <TableCell align="center" sx={{ color: "#000", fontWeight: "600", }}>
                                            {formatDate(txn?.transactionDate)}
                                        </TableCell>

                                        <TableCell>
                                            <Chip
                                                size="small"
                                                label={txn?.transactionStatus || "-"}
                                                color={getStatusColor(txn?.transactionStatus)}
                                            />
                                        </TableCell>

                                    </TableRow>
                                ))}

                            {!modalData?.registrations
                                ?.flatMap((reg) => reg?.AllTransactions || [])
                                ?.length && (
                                    <TableRow>
                                        <TableCell
                                            colSpan={7}
                                            align="center"
                                        >
                                            No Transactions Found
                                        </TableCell>
                                    </TableRow>
                                )}

                        </TableBody>
                    </Table>

                </CardContent>
            </Card>
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                gap={1}
                sx={{
                    position: "sticky",
                    bottom: 0,
                    background: "#fff",
                    p: 2,
                    borderTop: "1px solid #ddd"
                }}
            >

                <Button
                    variant="contained"
                    color="success"
                    startIcon={<DownloadIcon />}
                    onClick={handleDownloadPDF}
                >
                    Download PDF
                </Button>

                <Button
                    variant="contained"
                    color="primary"
                    onClick={closePopup}
                >
                    Close
                </Button>

            </Box>
        </Box>
    );
};

export default ViewOlympiadClubbingModal;